module.exports = __webpack_public_path__ + "fonts/FSSinclair-Medium.b3b6bfb7.otf";